/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Editors_Parq_PositiveInputs */

const en_us2_profile_editors_parq_positive = /** @type {(inputs: Profile_Editors_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`One positive answer: the plan starts more conservatively. Talk to a doctor before raising the intensity.`);
	return /** @type {LocalizedString} */ (`${i?.count} positive answers: the plan starts more conservatively. Talk to a doctor before raising the intensity.`)
	
};

const pt_br2_profile_editors_parq_positive = /** @type {(inputs: Profile_Editors_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Uma resposta positiva: o plano começa mais conservador. Converse com um médico antes de aumentar a intensidade.`);
	return /** @type {LocalizedString} */ (`${i?.count} respostas positivas: o plano começa mais conservador. Converse com um médico antes de aumentar a intensidade.`)
	
};

const es_419_profile_editors_parq_positive = /** @type {(inputs: Profile_Editors_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Una respuesta afirmativa: el plan empieza de forma más conservadora. Habla con un médico antes de subir la intensidad.`);
	return /** @type {LocalizedString} */ (`${i?.count} respuestas afirmativas: el plan empieza de forma más conservadora. Habla con un médico antes de subir la intensidad.`)
	
};

const pt_pt2_profile_editors_parq_positive = /** @type {(inputs: Profile_Editors_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Uma resposta positiva: o plano começa de forma mais conservadora. Fala com um médico antes de aumentares a intensidade.`);
	return /** @type {LocalizedString} */ (`${i?.count} respostas positivas: o plano começa de forma mais conservadora. Fala com um médico antes de aumentares a intensidade.`)
	
};

const fr_fr2_profile_editors_parq_positive = /** @type {(inputs: Profile_Editors_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Une réponse positive : le programme démarre plus prudemment. Parles-en à un médecin avant d'augmenter l'intensité.`);
	return /** @type {LocalizedString} */ (`${i?.count} réponses positives : le programme démarre plus prudemment. Parles-en à un médecin avant d'augmenter l'intensité.`)
	
};

const de_de2_profile_editors_parq_positive = /** @type {(inputs: Profile_Editors_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Ein Ja: Der Plan beginnt vorsichtiger. Sprich mit einer Ärztin oder einem Arzt, bevor du die Intensität steigerst.`);
	return /** @type {LocalizedString} */ (`${i?.count}-mal Ja: Der Plan beginnt vorsichtiger. Sprich mit einer Ärztin oder einem Arzt, bevor du die Intensität steigerst.`)
	
};

const it_it2_profile_editors_parq_positive = /** @type {(inputs: Profile_Editors_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Una risposta sì: la scheda parte in modo più prudente. Parla con un medico prima di aumentare l'intensità.`);
	return /** @type {LocalizedString} */ (`${i?.count} risposte sì: la scheda parte in modo più prudente. Parla con un medico prima di aumentare l'intensità.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "One positive answer: the plan starts more conservatively. Talk to a doctor before raising the intensity." |
* | * | "{count} positive answers: the plan starts more conservatively. Talk to a doctor before raising the intensity." |
*
* @param {Profile_Editors_Parq_PositiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_parq_positive = /** @type {((inputs: Profile_Editors_Parq_PositiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Parq_PositiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_parq_positive(inputs)
	if (locale === "es-419") return es_419_profile_editors_parq_positive(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_parq_positive(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_parq_positive(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_parq_positive(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_parq_positive(inputs)
	return en_us2_profile_editors_parq_positive(inputs)
});
export { profile_editors_parq_positive as "profile-editors.parq_positive" }